import { getElevationForLocations } from '../lib/ElevationAPI/elevation-API'
import { SUBIDS } from './enums'

export const unprintableCharsRegex = /[\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u037F-\u0383\u038B\u038D\u03A2\u0528-\u0530\u0557\u0558\u0560\u0588\u058B-\u058E\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08A1\u08AD-\u08E3\u08FF\u0978\u0980\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0C00\u0C04\u0C0D\u0C11\u0C29\u0C34\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5A-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C81\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D01\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5F\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F5-\u13FF\u169D-\u169F\u16F1-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191D-\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7-\u1CFF\u1DE7-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BB-\u20CF\u20F1-\u20FF\u218A-\u218F\u23F4-\u23FF\u2427-\u243F\u244B-\u245F\u2700\u2B4D-\u2B4F\u2B5A-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E3C-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FCD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA698-\uA69E\uA6F8-\uA6FF\uA78F\uA794-\uA79F\uA7AB-\uA7F7\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FC-\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9E0-\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAA7C-\uAA7F\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F-\uABBF\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE27-\uFE2F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]/g

export const renderIf = (test, component, component2) => (test ? component : component2 || undefined)

export const classToggler = options =>
  Object.keys(options)
    .filter(key => !!options[key])
    .join(' ')

export const log = (...args) => (__DEBUG__ ? console.log(...args) : undefined)

export const logError = (...args) => (__DEBUG__ ? console.error(...args) : undefined)

export const photoToDataURL = file => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.addEventListener('load', () => {
      resolve(reader.result)
    })
    reader.addEventListener('error', () => {
      reject(reader.error)
    })
    if (file) return reader.readAsDataURL(file)
    return reject(new Error('USAGE ERROR: requires file'))
  })
}

export const degrees2meters = (lon, lat) => {
  let xm = (lon * 20037508.34) / 180
  let ym = Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180)
  ym = (ym * 20037508.34) / 180

  return { xm, ym }
}

export const sortByDistance = (center, items, shape, mapItems) => {
  return new Promise(resolve => {
    if (!shape) {
      for (let i = 0; i < items.length; i++) {
        items[i]['distance'] = calculateDistance(center.lat(), center.lng(), items[i].latitude, items[i].longitude, 'K')
      }
    }

    if (shape && shape !== 'boundary') {
      for (let i = 0; i < items.length; i++) {
        let mapItem = mapItems.find(m => m.metadata.id == items[i].id)
        items[i]['distance'] = calculateDistance(
          center.lat(),
          center.lng(),
          getBoundsCenter(mapItem, shape).lat(),
          getBoundsCenter(mapItem, shape).lng(),
          'K'
        )
      }
    }

    if (shape && shape == 'boundary') {
      for (let i = 0; i < items.length; i++) {
        let lat,
          lng = 0
        if (items[i].mapBoundaryCamera) {
          lat = items[i].mapBoundaryCamera.targetLatitude
          lng = items[i].mapBoundaryCamera.targetLongitude
        } else {
          lat = items[i].latitudeLowerRight
          lng = items[i].longitudeLowerRight
        }
        items[i]['distance'] = calculateDistance(center.lat(), center.lng(), lat, lng, 'K')
      }
    }

    items.sort((a, b) => a.distance - b.distance)
    resolve(items)
  })
}

const calculateDistance = (lat1, lon1, lat2, lon2, unit) => {
  var radlat1 = (Math.PI * lat1) / 180
  var radlat2 = (Math.PI * lat2) / 180
  var radlon1 = (Math.PI * lon1) / 180
  var radlon2 = (Math.PI * lon2) / 180
  var theta = lon1 - lon2
  var radtheta = (Math.PI * theta) / 180
  var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
  dist = Math.acos(dist)
  dist = (dist * 180) / Math.PI
  dist = dist * 60 * 1.1515
  if (unit == 'K') {
    dist = dist * 1.609344
  }
  if (unit == 'N') {
    dist = dist * 0.8684
  }
  return dist
}

const getBoundsCenter = (mapItem, shape) => {
  let bounds = new google.maps.LatLngBounds()
  if (mapItem) {
    if (shape == 'circles') {
      for (let j = 0; j < 361; j = j + 8) {
        let circumLatLng = google.maps.geometry.spherical.computeOffset(
          mapItem.getCenter(),
          mapItem.getRadius(),
          (90.0 - j + 360.0) % 360.0
        )
        bounds.extend(circumLatLng)
      }
    } else {
      mapItem.getPath().forEach(p => {
        bounds.extend(p)
      })
    }
  }

  return bounds.getCenter()
}

export const sortByCreated = (center, items) => {
  return new Promise(resolve => {
    items = items.sort((a, b) => b.id - a.id)
    resolve(items)
  })
}

export const sortByCreatedDate = (center, items) => {
  return new Promise(resolve => {
    items = items.sort((a, b) => new Date(b.created.split('Z')[0]) - new Date(a.created.split('Z')[0]))
    resolve(items)
  })
}

export const validateEmail = email => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export const generateDefaultName = (baseName, objectList) => {
  let number = 0
  if (objectList && objectList.length > 0) {
    objectList.map(o => {
      if (o.name && o.name.startsWith(baseName)) {
        let objectParts = o.name.split(' - ')
        if (objectParts && objectParts.length === 2 && objectParts[1] > number) {
          number = Number(objectParts[1])
        }
      }
    })
  }

  return baseName + (number + 1)
}

export const jSON_parse = data => {
  let parsedJSON = {}
  try {
    parsedJSON = JSON.parse(data)
    // eslint-disable-next-line no-empty
  } catch (error) { }

  return parsedJSON
}

export const getBaseURL = () => {
  if (typeof window !== 'undefined') {
    return location.protocol + '//' + location.host
  } else {
    return null
  }
}

export const mobileParse = (value, previous) => {
  const mobile = value
  const prev = previous
  let next
  // checks for:
  if (mobile.match(/^\d$/)) {
    // one digit and adds the paren
    next = '(' + mobile
  } else if (mobile.match(/^$/)) {
    // nothing stays nothing important for deleting all chars
    next = ''
  } else if (mobile.match(/^\($/)) {
    // just paren and removes it
    next = ''
  } else if (mobile.match(/^\(\d{1,2}$/)) {
    // adding second number keeps the same
    next = mobile
  } else if (mobile.match(/^\(\d{3}$/)) {
    // if third number is added add paren and space
    next = mobile + ') '
  } else if (mobile.match(/^\(\d{3}\)$/)) {
    // if space is gone remove paren and number
    next = mobile.slice(0, -2)
  } else if (mobile.match(/^\(\d{3}\) \d{0,2}$/)) {
    // update for middle numbers
    next = mobile
  } else if (mobile.match(/^\(\d{3}\) \d{3}$/)) {
    // added last middle digit then add dash and spaces
    next = mobile + ' - '
  } else if (mobile.match(/^\(\d{3}\) \d{3} -$/)) {
    // if space after dash is removed remove three chars
    next = mobile.slice(0, -3)
  } else if (mobile.match(/^\(\d{3}\) \d{3} - \d{0,4}$/)) {
    // update for last four digits
    next = mobile
  } else {
    next = prev
  }

  return next
}

// Returns a date with format Set 9th, 2018
export const formatDate = date => {
  let displayDate = Date.now()

  displayDate = new Date(displayDate)
  if (date) {
    displayDate = new Date(date)
  }

  let formatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }
  let displayDateString = displayDate.toLocaleDateString('en-US', formatOptions)

  displayDateString = displayDateString.split(' ')

  displayDateString[0] = displayDateString[0] + '.'

  displayDateString[1] = displayDateString[1].split(',')[0]

  displayDateString[1] =
    displayDateString[1] +
    (displayDateString[1].split('')[displayDateString[1].length - 1] == '1'
      ? 'st'
      : displayDateString[1].split('')[displayDateString[1].length - 1] == '3'
        ? 'rd'
        : displayDateString[1].split('')[displayDateString[1].length - 1] == '2'
          ? 'nd'
          : 'th')

  displayDateString[1] = displayDateString[1] + ','
  displayDateString[2] = parseInt(displayDateString[2].trim().replace(unprintableCharsRegex, ''))
  displayDateString = displayDateString.join(' ')

  return displayDateString
}

export const numToCommaStr = num => {
  const running = [],
    decimal = `${num}`.split('.')[1]
  let numLocal = Math.floor(Math.abs(num)) * Math.sign(num)
  while (Math.abs(numLocal) > 1) {
    const set = numLocal % 1000
    numLocal -= set
    running.unshift(set)
    numLocal /= 1000
  }
  running.forEach((num, idx) => {
    if (idx > 0) {
      const tmp = '' + num,
        str = tmp.length === 3 ? tmp :
          tmp.length === 2 ? `0${tmp}` :
            tmp.length === 1 ? `00${tmp}` : '000'
      running[idx] = str
    }
  })
  return `${running.join(',')}${decimal ? '.' + decimal : ''}`
}

export const formatDateTime = date => {
  let displayDate = Date.now()

  displayDate = new Date(displayDate)
  if (date) {
    date.length > 24 ? date = date.slice(0, 24) : null
    displayDate = new Date(date)
  }

  var localOffset = displayDate.getTimezoneOffset() * 60000
  var localTime = displayDate.getTime()
  displayDate = localTime - localOffset
  displayDate = new Date(displayDate)
  let formatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }
  let displayDateString = displayDate.toLocaleDateString('en-US', formatOptions)

  displayDateString = displayDateString
    .replace(',', ' @ ')
    .replace('PM', 'p.m.')
    .replace('AM', 'a.m.')

  return displayDateString
}

const convertDDToDMS = (decimalDegree, direction) => {
  let running = Math.abs(decimalDegree)
  let degrees = parseInt(running, 10)
  running = (running - degrees) * 60
  let minutes = parseInt(running)
  running = running - minutes
  let seconds = Math.round(running * 60)
  const secText = seconds < 10 ? '0' + seconds : seconds
  const minText = minutes < 10 ? '0' + seconds : seconds
  let latitud = {
    degrees,
    minutes,
    seconds,
    direction,
    text: `${degrees}º ${minText}' ${secText}" ${direction}`
  }

  return latitud
}

const convertDMSToDD = (dmsObject, symbol) => {
  return (dmsObject.degrees + dmsObject.minutes / 60 + dmsObject.seconds / 3600) * symbol
}

// returns object with string with format DD:MM.MM N|S
export const convertLatDDToDMS = lat => {
  let latitud = null
  let value = Number.isFinite(lat) ? lat : typeof lat === 'function' ? lat() : null

  if (value) {
    let direction = value > 0 ? 'N' : 'S'
    latitud = convertDDToDMS(value, direction)
  }
  return latitud
}

// returns number with format -|+DD.DD
export const convertLatDMSToDD = dmsLat => {
  if (dmsLat && dmsLat.degrees && dmsLat.direction) {
    return convertDMSToDD(dmsLat, dmsLat.direction === 'N' ? 1 : -1)
  }

  return null
}

// returns string with format DD:MM.MM E|W
export const convertLngDDToDMS = lng => {
  let longitud = null
  let value = Number.isFinite(lng) ? lng : typeof lng === 'function' ? lng() : null

  if (value) {
    let direction = value > 0 ? 'E' : 'W'
    longitud = convertDDToDMS(value, direction)
  }
  return longitud
}

// returns number with format -|+DD.DD
export const convertLngDMSToDD = dmsLng => {
  if (dmsLng && dmsLng.degrees && dmsLng.direction) {
    return convertDMSToDD(dmsLng, dmsLng.direction === 'E' ? 1 : -1)
  }

  return null
}

export const convertElevationToUnitSystem = (measureType, elevation) => {
  return measureType === 'imperial' ?
    `${Math.round((elevation * 3.28084).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ft` :
    `${Math.round(elevation.toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} m`
}

export const getPointElevation = latlan => {
  return new Promise((resolve, reject) => {
    if (latlan) {
      getElevationForLocations([latlan])
        .then(results => {
          resolve(results[0].elevation)
          return results[0].elevation
        })
        .catch(err => reject(err))
    } else {
      reject()
      return null
    }
  })
}

export const isObjectEmpty = obj => {
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

export const needScrollBarDown = refObject => {
  return (
    refObject &&
    refObject.current &&
    refObject.current.offsetHeight < refObject.current.scrollHeight &&
    refObject.current.scrollHeight - refObject.current.scrollTop - refObject.current.clientHeight > 0
  )
}

export const needScrollBarUp = refObject => {
  return refObject && refObject.current && refObject.current.scrollTop > 0
}

export const isOverflown = refObject => {
  return (
    refObject.current.scrollHeight > refObject.current.clientHeight ||
    refObject.current.scrollWidth > refObject.current.clientWidth
  )
}

// compares 2 different arrays and returns true if the contents match regardless of the other they are in
export const arrayIsEqual = (array1, array2) => {
  if (array1 && array2 && array1.length && array2.length) {
    if (array1.length === array2.length) {
      let equals = true
      if (!array1 === array2) {
        array1.map(x => {
          if (!array2.find(y => x === y)) {
            equals = false
          }
        })
      }

      return equals
    } else {
      return false
    }
    // support normal compare just in case.
  } else if (array2 === array1) {
    return true
  } else {
    return false
  }
}

export const localDate = date => {
  let displayDate = new Date(date)
  var localOffset = displayDate.getTimezoneOffset() * 60000
  var localTime = displayDate.getTime()
  displayDate = localTime - localOffset
  displayDate = new Date(displayDate)
  let formatOptions = {
    day: '2-digit',
    month: 'short'
  }
  let displayDateString = displayDate.toLocaleDateString('en-US', formatOptions)

  displayDateString = displayDateString.replace(',', '')

  return displayDateString
}

export const checkFileExtension = (file, extensionToCompare, mimeType) => {
  let isExtension = false
  if (file) {
    if (extensionToCompare) {
      let fileParts = file.name.split('.')
      if (fileParts && fileParts.length > 1) {
        let extension = fileParts[fileParts.length - 1]
        if (extension.toUpperCase() === extensionToCompare.toUpperCase()) {
          isExtension = true
        }
      }
    } else if (mimeType) {
      let mimeParts = mimeType.split('/')
      if (mimeParts.length === 2) {
        if (mimeParts[1] === '*') {
          if (file.type.includes(mimeParts[0])) {
            isExtension = true
          } else if (file.type == mimeType) {
            isExtension = true
          }
        }
      }
    }
  }

  return isExtension
}

export const checkFileExtensions = (file, extensionsToCompare) => {
  let isCorrectExtension = false

  extensionsToCompare.map(t => {
    let extensionMatches = checkFileExtension(file, t, null)
    if (extensionMatches) {
      isCorrectExtension = extensionMatches
    }
  })

  return isCorrectExtension
}

export const latLng2Pixel = (latLng, map) => {
  if (map) {
    let topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast())
    let bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest())
    let scale = Math.pow(2, map.getZoom())
    let worldPoint = map.getProjection().fromLatLngToPoint(latLng)
    return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale)
  }
}

export const getBoundingClientRect = element => {
  if (element) {
    const { top, right, bottom, left, width, height, x, y } = element.getBoundingClientRect()
    return { top, right, bottom, left, width, height, x, y }
  } else {
    return null
  }
}

const _MS_PER_DAY = 1000 * 60 * 60 * 24
// a and b are javascript Date objects
export const dateDiffInDays = (startDate, endDate) => {
  let start = startDate
  let end = endDate
  let diffDays = 0
  if (startDate && endDate) {
    if (Object.prototype.toString.call(start) !== '[object Date]') {
      start = new Date(start)
    }

    if (Object.prototype.toString.call(end) !== '[object Date]') {
      end = new Date(end)
    }

    // Discard the time and time-zone information.
    const utc1 = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate())
    const utc2 = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate())

    diffDays = Math.floor((utc2 - utc1) / _MS_PER_DAY)
  }

  return diffDays
}

export const hideMapObjects = objs => {
  objs.forEach(obj => {
    if (obj.mapObj && obj.mapObj().getMap() !== null) {
      obj.mapObj().setMap(null)
    }
  })
}

export const showMapObjects = (objs, map) => {
  objs.forEach(obj => {
    if (obj.mapObj && obj.mapObj().getMap() === null) {
      obj.mapObj().setMap(map)
    }
  })
}

export const formatLongDate = (d1) => {
  if (!d1)
    return '';
  if (!d1.endsWith('Z')) d1 += 'Z';
  return new Date(d1).toLocaleString('en-us', { weekday: "short", year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric" });
}

export const formatNumberWithCommas = (v1) => {
  return v1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const userHasPro = (user) => {
  const { PRO, PRO_ULTIMATE, HUNT } = SUBIDS,
    { userSubscription } = user

  return userSubscription.some(sub => sub.subscriptionPlanId === PRO || sub.subscriptionPlanId === PRO_ULTIMATE || sub.subscriptionPlanId == HUNT || sub.subscriptionPlanId == 36)
}

export const userHasSubscription = (user, planIds) => {
  const { userSubscription } = user;
  return userSubscription.some(sub => planIds.includes(sub.subscriptionPlanId));
};

export const userHasHunt = (user) => {
  const { HUNT } = SUBIDS;
  return userHasSubscription(user, [HUNT]);
};

export const userHasProAdvantage = (user) => {
  const { PRO_ADVANTAGE } = SUBIDS;
  return userHasSubscription(user, [PRO_ADVANTAGE]);
};

export const userHasProUltimate = (user) => {
  const { PRO_ULTIMATE } = SUBIDS;
  return userHasSubscription(user, [PRO_ULTIMATE]);
};

export const formattedText = (value) => { return value.replace(/[_~]/g, " ").replace(/\b\w/g, c => c.toUpperCase()); }

